import { isNotString, keys, notInArray, values } from "@buurman/sdk";
import { HOOKS } from "./constants";
import { Huskyrc } from "./models";

export const validateHooks = (hooks: Huskyrc["hooks"]) => {
    if (!hooks || typeof hooks !== "object") {
        return "hooks options is not an object";
    }

    const invalidHookNames = keys(hooks).filter(notInArray(HOOKS));

    if (invalidHookNames.length) {
        const noun = invalidHookNames.length > 1 ? "hooks" : "hook";

        return (
            `Invalid ${noun}: ${invalidHookNames.join(", ")}.\n\n` +
            `Please refer to https://git-scm.com/docs/githooks ` +
            `for a list of valid git hooks.`
        );
    }

    const invalidCommands = values(hooks).filter(isNotString);

    if (invalidCommands.length) {
        const noun = invalidCommands.length > 1 ? "commands" : "command";

        return (
            `Invalid ${noun}: ${invalidCommands.join(", ")}.\n\n` +
            `Commands must be strings.`
        );
    }

    return true;
};
